import React from 'react';
import _ from 'underscore';
import classNames from 'classnames';
import { DirectionalHint } from '@bingads-webui-react/fabric-control';
import { StyledBaMenuItem } from '@bingads-webui-react/global-menu';

function recursiveGeneratePropsFactory({
  classes, i18n, navigate, onClickDefaultReportItem,
}) {
  return function recursiveGenerateProps({ siteMapItem }) {
    return siteMapItem.children.map((siteMapChild) => {
      const menuItem = {
        key: siteMapChild.id,
        text: i18n.getString(siteMapChild.name),
      };

      if (siteMapChild.children.length > 0) {
        menuItem.subMenuProps = {
          directionalHint: DirectionalHint.rightTopEdge,
          calloutProps: {
            preventDismissOnScroll: true,
          },
          items: recursiveGenerateProps({ siteMapItem: siteMapChild }),
        };
      } else {
        menuItem.onRender = (_menuItem, dismissMenu) => (
          <StyledBaMenuItem
            className={classNames([classes.menuItem, classes.toggleable])}
            key={siteMapChild.id}
            menuItemKey={siteMapChild.id}
            calloutPlacement="right"
            route={siteMapChild.route}
            dismissMenu={dismissMenu}
            closeDropdown={() => dismissMenu(null, true)}
            customizedOnClick={() => {
              navigate(siteMapChild.route);
              onClickDefaultReportItem({ menuItem: _menuItem });
            }}
            directionalHint={DirectionalHint.rightCenter}
          >
            {i18n.getString(siteMapChild.name)}
          </StyledBaMenuItem>);
      }

      return menuItem;
    });
  };
}


export function generateDefaultReportMenuItem({
  siteMap, i18n, classes, onClickDefaultReportItem, navigate, allReportsTitle,
}) {
  const siteMapItem = _.find(siteMap[0].children, { id: 'reports-v4-default-reports' });

  const recursiveGenerateProps = recursiveGeneratePropsFactory({
    classes, i18n, navigate, onClickDefaultReportItem,
  });

  const menuText = i18n.getString(_TL_('Default reports'));

  const rootMenuItem = {
    key: 'default-reports-title',
    text: menuText,
    className: 'reports-v4-bar-default-reports',
    onClick: (event, menuItem) => {
      navigate(siteMapItem.fixedRoute);
      onClickDefaultReportItem({ menuItem });
    },
    split: true,
    'aria-roledescription': 'split button',
    ariaLabel: `${allReportsTitle} ${menuText}`,
    subMenuProps: {
      directionalHint: DirectionalHint.rightTopEdge,
      calloutProps: {
        preventDismissOnScroll: true,
      },
      items: recursiveGenerateProps({ siteMapItem }),
    },
  };

  return rootMenuItem;
}
